/** Hono RPC クライアント（型安全、認証付き） */

import type { labelsRoute } from "@payload-alpha/api/routes/labels";
import type { shoppingSessionsRoute } from "@payload-alpha/api/routes/shopping-sessions";
import type { syncRoute } from "@payload-alpha/api/routes/sync";
import type { todosRoute } from "@payload-alpha/api/routes/todos";
import type { userSettingsRoute } from "@payload-alpha/api/routes/user-settings";
import type { venuesRoute } from "@payload-alpha/api/routes/venues";
import { hc } from "hono/client";
import { getIdToken, logout, refreshTokens, restoreIdToken } from "./auth";

/** 認証付き fetch — Token 自動付与 + 401 時 refresh リトライ */
const authFetch: typeof fetch = async (input, init) => {
  await restoreIdToken();
  const token = getIdToken();
  const headers = new Headers(init?.headers);
  if (token) {
    headers.set("Authorization", `Bearer ${token}`);
  }

  let res = await fetch(input, { ...init, headers });

  if (res.status === 401) {
    const refreshed = (await refreshTokens()) === "refreshed";
    if (refreshed) {
      const newToken = getIdToken();
      if (newToken) {
        headers.set("Authorization", `Bearer ${newToken}`);
      }
      res = await fetch(input, { ...init, headers });
    } else {
      // unreachable でも logout() して refresh_token を消している。頻度が低いため見送り:
      // https://github.com/galactic1969/payload-alpha/issues/177
      logout();
    }
  }

  return res;
};

export const api = hc<typeof todosRoute>("/api/todos", { fetch: authFetch });
export const labelsApi = hc<typeof labelsRoute>("/api/labels", {
  fetch: authFetch,
});
export const userSettingsApi = hc<typeof userSettingsRoute>(
  "/api/users/me/settings",
  { fetch: authFetch },
);
export const shoppingSessionsApi = hc<typeof shoppingSessionsRoute>(
  "/api/shopping-sessions",
  { fetch: authFetch },
);
export const syncApi = hc<typeof syncRoute>("/api/sync", { fetch: authFetch });
export const venuesApi = hc<typeof venuesRoute>("/api/venues", {
  fetch: authFetch,
});
